import { IMAGE_URL_REGEX } from './validator'

export const sleep = (ms: number) => {
  return new Promise(resolve => setTimeout(resolve, ms))
}

export async function asyncRunSafe<T = any>(
  fn: Promise<T>,
): Promise<[Error] | [null, T]> {
  try {
    return [null, await fn]
  } catch (e) {
    if (e instanceof Error) return [e]
    return [new Error('unknown error')]
  }
}

export const getTextWidthWithCanvas = (text: string, font?: string) => {
  const canvas = document.createElement('canvas')
  const ctx = canvas.getContext('2d')
  if (ctx) {
    ctx.font =
      font ??
      '12px Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"'
    return Number(ctx.measureText(text).width.toFixed(2))
  }
  return 0
}

const chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ-_'

export function randomString(length: number) {
  let result = ''
  for (let i = length; i > 0; --i)
    result += chars[Math.floor(Math.random() * chars.length)]
  return result
}

export const getPurifyHref = (href: string) => {
  if (!href) return ''

  return href
    .replace(/javascript:/gi, '')
    .replace(/vbscript:/gi, '')
    .replace(/data:/gi, '')
}

export const toStandardUUIDFormat = (uuid: string | undefined) => {
  if (!uuid) return ''
  if (uuid === 'default') {
    return 'default'
  }
  // check if the uuid is already in standard format
  if (uuid.length === 36) {
    return uuid
  }
  const parts = [
    uuid.slice(0, 8),
    uuid.slice(8, 12),
    uuid.slice(12, 16),
    uuid.slice(16, 20),
    uuid.slice(20),
  ]
  return parts.join('-')
}

export const toShortUUID = (uuid: string | undefined) => {
  if (!uuid) return ''
  if (uuid === 'default') {
    return 'default'
  }
  return uuid.replace(/-/g, '')
}

export function isValidUUID(uuid: string) {
  return uuid.length === 36 && uuid.split('-').length === 5
}

export function parseDockerImageUrl(imageUrl: string) {
  // 正则表达式来匹配 docker 镜像 URL 的不同部分
  const match = IMAGE_URL_REGEX.exec(imageUrl)

  if (!match) {
    throw new Error('Invalid Docker image URL')
  }

  // 使用索引访问捕获组
  const registry = match[1]
  const fullName = match[2] || match[3] // 包含命名空间和名称，如果为官方镜像，则不含命名空间
  const [namespace, name] = fullName.includes('/')
    ? fullName.split('/')
    : [undefined, fullName]
  const tag = match[4]

  return {
    registry: registry ? registry.replace(/\/$/, '') : 'docker.io',
    namespace: namespace || 'library', // 如果没有命名空间，默认使用 'library'
    name: name,
    tag: tag || 'latest', // 如果没有标签，默认使用 'latest'
  }
}

export const formatDate = function (d: Date) {
  function pad2(n: number) {
    // always returns a string
    return (n < 10 ? '0' : '') + n
  }

  return (
    d.getFullYear() +
    pad2(d.getMonth() + 1) +
    pad2(d.getDate()) +
    pad2(d.getHours()) +
    pad2(d.getMinutes()) +
    pad2(d.getSeconds())
  )
}

export function updateTime(str: string) {
  const regex = /\d{14}$/
  // 将日期格式化为YYYYMMDDHHMMSS格式
  let formattedDate = formatDate(new Date())

  if (regex.test(str)) {
    // 如果字符串以14位数字结尾
    // 截去原来的日期并加上新的时间戳
    return str.slice(0, -14) + formattedDate
  } else {
    // 如果字符串不以14位数字结尾
    // 直接加上新的时间戳
    return str + '-' + formattedDate
  }
}

export function isLinuxTimestamp(timestamp: number) {
  if (typeof timestamp !== 'number' || !Number.isFinite(timestamp)) {
    return false // 必须是一个有效数字
  }

  // 检查是否是秒级时间戳
  const isSeconds = timestamp >= 0 && timestamp <= 4294967295

  // 检查是否是毫秒级时间戳
  // const isMilliseconds = timestamp >= 0 && timestamp <= 253402300799999

  return isSeconds
}
